import {
  ComprobantePagoList,
  ComprobantePagoNoEnviadoList,
  NotaVentaList,
  ResumenList,
  CotizacionList,
  PuntoVentaScreen,
  TerminalCajeroList,
  CajasList,
  CierreCajaScreen,
  MovimientosCajaList,
  PedidoVentaList,
} from "../components/ventas";

import {
  InventarioProductoList,
  KardexList,
  MovimientoTrasladoList,
  MovimientoEntradaScreen,
  MovimientosList,
  InventarioInicialList,
  PeriodoContableList,
} from "../components/inventario";

import { ComprobanteCompraList } from "../components/compras/comprobantecompra/ComprobanteCompraList";

import { Dashboard } from "../components/dashboard/Dashboard";

import { EmpleadoList } from "../components/rrhh/empleados/EmpleadoList";

import { ProductosList } from "../components/productos/ProductosList";
import { ListaPrecioList } from "../components/items/listaprecio/ListaPrecioList";

import {
  ProgramacionTejidoList,
  ProgramacionTintoreriaList,
  TareaProduccionList,
  RutaProduccionList,
  MaquinaList,
  ProcesoProduccionList,
  OrdenProduccionList,
  ResumenProduccionList,
} from "../components/produccion";

import {
  ProveedorList,
  GeneralesList,
  EmpresasList,
  LocalesList,
  ClienteList,
  CentroCostosList,
} from "../components/generales";

import { ModuloList, PerfilList, UsuarioList } from "../components/auth";
import { NotificacionesList } from "../components/notificaciones/NotificacionesList";

const componentes_routes = [
  { key: "ComprobantePagoList", Componente: ComprobantePagoList },
  {
    key: "ComprobantePagoNoEnviadoList",
    Componente: ComprobantePagoNoEnviadoList,
  },
  { key: "NotaVentaList", Componente: NotaVentaList },
  { key: "ResumenList", Componente: ResumenList },
  { key: "CotizacionList", Componente: CotizacionList },
  { key: "PuntoVentaScreen", Componente: PuntoVentaScreen },
  { key: "TerminalCajeroList", Componente: TerminalCajeroList },
  { key: "CajasList", Componente: CajasList },
  { key: "CierreCajaScreen", Componente: CierreCajaScreen },
  { key: "MovimientosCajaList", Componente: MovimientosCajaList },
  { key: "PedidoVentaList", Componente: PedidoVentaList },

  { key: "InventarioProductoList", Componente: InventarioProductoList },
  { key: "KardexList", Componente: KardexList },
  { key: "MovimientoTrasladoList", Componente: MovimientoTrasladoList },
  { key: "MovimientoEntradaScreen", Componente: MovimientoEntradaScreen },
  { key: "MovimientosList", Componente: MovimientosList },
  { key: "InventarioInicialList", Componente: InventarioInicialList },
  { key: "PeriodoContableList", Componente: PeriodoContableList },
  { key: "ComprobanteCompraList", Componente: ComprobanteCompraList },

  { key: "Dashboard", Componente: Dashboard },
  { key: "EmpleadoList", Componente: EmpleadoList },

  { key: "ProductosList", Componente: ProductosList },
  { key: "ListaPrecioList", Componente: ListaPrecioList },

  { key: "ProgramacionTejidoList", Componente: ProgramacionTejidoList },
  { key: "ProgramacionTintoreriaList", Componente: ProgramacionTintoreriaList },
  { key: "TareaProduccionList", Componente: TareaProduccionList },
  { key: "RutaProduccionList", Componente: RutaProduccionList },
  { key: "MaquinaList", Componente: MaquinaList },
  { key: "ProcesoProduccionList", Componente: ProcesoProduccionList },
  { key: "OrdenProduccionList", Componente: OrdenProduccionList },
  { key: "ResumenProduccionList", Componente: ResumenProduccionList },

  { key: "ProveedorList", Componente: ProveedorList },
  { key: "GeneralesList", Componente: GeneralesList },
  { key: "ClienteList", Componente: ClienteList },
  { key: "EmpresasList", Componente: EmpresasList },
  { key: "LocalesList", Componente: LocalesList },
  { key: "CentroCostosList", Componente: CentroCostosList },
  { key: "ModuloList", Componente: ModuloList },
  { key: "PerfilList", Componente: PerfilList },
  { key: "UsuarioList", Componente: UsuarioList },
  { key: "NotificacionesList", Componente: NotificacionesList },
];

const routes_permanent_redirect = [
  {
    id: 0,
    nombre: "nuevo movimiento entrada",
    path: "/inventario/movimientoentrada",
    eslink: true,
    orden: 0,
    modulo_id: null,
    rutapadre_id: null,
    componente: "MovimientoEntradaScreen",
    icono: null,
  },
];

export { componentes_routes, routes_permanent_redirect };
